import { render, staticRenderFns } from "./pixFlag.vue?vue&type=template&id=56b7ada6&scoped=true"
import script from "./pixFlag.vue?vue&type=script&lang=js"
export * from "./pixFlag.vue?vue&type=script&lang=js"
import style0 from "./pixFlag.vue?vue&type=style&index=0&id=56b7ada6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b7ada6",
  null
  
)

export default component.exports